/* eslint-disable @typescript-eslint/no-explicit-any */
import {useRef} from 'react';

export function useDebounce<T extends (...args: any[]) => void>(callback: T, delay: number = 500) {
	const timeoutId = useRef<NodeJS.Timeout>();

	const debounce = (...args: Parameters<T>) => {
		clearTimeout(timeoutId.current);

		timeoutId.current = setTimeout(() => {
			callback(...args);
		}, delay);
	};

	const cancel = () => {
		if (timeoutId.current) clearTimeout(timeoutId.current);
	};

	return [debounce, cancel] as const;
}
